import {
  homePath,
  supporterPath,
  adminPath,
  peerSupporterLeadPath,
} from './route.constants'
import { Home } from '../pages'
import { Pages } from '../pages/constants'

export interface RouteType {
  path?: string
  component: React.ReactNode
  exact: boolean
}

export const routes: RouteType[] = [
  {
    path: homePath,
    component: <Home page={Pages.HOMEPAGE} />,
    exact: true,
  },
  {
    path: supporterPath,
    component: <Home page={Pages.SUPPORTPAGE} />,
    exact: true,
  },
  {
    path: adminPath,
    component: <Home page={Pages.ADMINPAGE} />,
    exact: true,
  },
  {
    path: peerSupporterLeadPath,
    component: <Home page={Pages.PEERSUPPORTERLEAD} />,
    exact: true,
  },
]
